import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import LayersIcon from '@mui/icons-material/Layers';
import AssignmentIcon from '@mui/icons-material/Assignment';

import SignIn from './SignIng';
import {
    BrowserRouter as Router,
    Route,
    Link
} from "react-router-dom";

export const mainListItems = (
    <React.Fragment>
        <Link to={'/'} style={{ textDecoration: 'none', color: '#000000de' }}>
            <ListItemButton >
                <ListItemIcon>
                    <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="Inicio" />
            </ListItemButton>
        </Link>
        <Link to={'/exams'} style={{ textDecoration: 'none', color: '#000000de' }}>
            <ListItemButton >
                <ListItemIcon>
                    <EditIcon />
                </ListItemIcon>
                <ListItemText primary="Examenes" />
            </ListItemButton>
        </Link >
        <Link to={'/admin'} style={{ textDecoration: 'none', color: '#000000de' }}>
            <ListItemButton>
                <ListItemIcon>
                    <AddBoxIcon />
                </ListItemIcon>
                <ListItemText primary="Admin" />
            </ListItemButton>
        </Link>
    </React.Fragment>
);

export const secondaryListItems = (
    <React.Fragment>
        <ListSubheader component="div" inset>
            Configuraciones
        </ListSubheader>
        <ListItemButton onClick={() => {
            global.setUserForPadron()
        }}>
            <ListItemIcon>
                <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Registro" />
        </ListItemButton>
    </React.Fragment>
);